<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      clearable
      no-filter
      @click:clear="onclear"
      :height="(multiple ? null : (height ? height : '32'))"
      :hide-details="(rules ? false : true)"
      return-object
      item-text="name"
      :rules="(rules ? rules : [])"
      :required="(rules ? true : false)"
      item-value="id"
      :label="$t(title)"
      :dense="(multiple || offDens ? false : true)"
      :chips="(multiple ? multiple : null)"
      :multiple="(multiple ? multiple : null)"
      :outlined="(outlined ? outlined : (solo ? false : true))"
      :solo="solo"
      :flat="flat"
      @click="openMobileDialog"
      :background-color="(backroundColor ? backroundColor : null)"
      :menu-props="{
        maxHeight: (isMobile ? 0 : 200),
        nudgeWidth: 0,
      }"
    >
      <template
        v-if="solo && title"
        v-slot:prepend
      >
        <p class="mx-auto mt-1 font-weight-medium">
          {{ $t(title) }}
        </p>
      </template>
<!--      <template v-slot:append>-->
<!--        <v-slide-x-reverse-transition-->
<!--          mode="out-in"-->
<!--        >-->
<!--          <v-icon-->
<!--            :key="`icon-${appendIcon}`"-->
<!--            :color="notFind ? 'success' : 'secondary'"-->
<!--            @click="appendIcon = !appendIcon"-->
<!--            v-text="notFind ? 'mdi-check-outline' : 'mdi-chevron-down'"-->
<!--          />-->
<!--        </v-slide-x-reverse-transition>-->
<!--      </template>-->
      <template v-slot:no-data>
        <!--        <v-list-item>-->
        <!--          <v-list-item-content>-->
        <!--            <v-list-item-title v-text="search" />-->
        <!--            <v-list-item-subtitle>{{ $t('no-data') }}</v-list-item-subtitle>-->
        <!--          </v-list-item-content>-->
        <!--          <v-list-item-action>-->
        <!--            <v-icon color="success">-->
        <!--              mdi-check-outline-->
        <!--            </v-icon>-->
        <!--          </v-list-item-action>-->
        <!--        </v-list-item>-->
      </template>
      <template
        v-if="!multiple"
        v-slot:selection="{item}"
      >
        <span v-text="item.name" />
      </template>
      <template
        v-if="multiple"
        v-slot:selection="{item}"
      >
        <v-chip
          close
          small
          dark
          :color="item.color"
          class="mb-1"
          @click:close="remove(item)"
        >
          {{ item.name }}
        </v-chip>
      </template>
      <template
        v-slot:append
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="append"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              v-on="on"
              @click="setDefault"
            >
              <v-icon
                medium
              >
                mdi-account-check-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('set-to-default') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="newBtn"
              color="primary"
              v-bind="attrs"
              icon
              small
              style="margin: 0px !important;margin-top: -3px !important;"
              v-on="on"
              @click.stop.prevent="openNew"
            >
              <v-icon
                medium
              >
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span> {{$t(title)}} ({{ $t('new') }})</span>
        </v-tooltip>
      </template>
      <template v-slot:append-item>
        <div
          v-if="items.length !== 0 && last_page > 1"
          v-observe-visibility="{
            callback: visibilityChanged
          }"
          class="text-center"
        >
          <v-progress-circular
            :size="20"
            :width="2"
            color="primary"
            indeterminate
          />
        </div>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="item.name" />
          <!--        <v-list-item-subtitle v-text="item.symbol" />-->
        </v-list-item-content>
        <v-list-item-action>
          <v-icon v-if="type== 'person'">
            mdi-account
          </v-icon>
          <v-chip
            v-if="item.label"
            class="mx-0"
            :color="item.color"
            label
            x-small
            outlined
          >
            {{ item.label }}
          </v-chip>
        </v-list-item-action>
        <v-list-item-action
          class="d-inline"
          @click.stop
        >
          <v-btn
            v-if="newBtn && $store.state.permissions.includes('removeCategoryItem')"
            icon
            small
            @click.stop.prevent="edit(item)"
          >
            <v-icon color="grey">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="newBtn && $store.state.permissions.includes('removeCategoryItem')"
            small
            icon
            @click.stop.prevent="removeItem(item)"
          >
            <v-icon color="pink">
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </v-autocomplete>
      <v-dialog
      v-model="mobileDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar
          fixed
          color="primary"
          elevation="4"
          class="px-3"
        >
          <v-app-bar-nav-icon>
            <v-btn
              icon
              dark
              @click="mobileDialog = false"
            >
              <v-icon
                color="white"
                style="font-size: 20px"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </v-app-bar-nav-icon>

          <v-toolbar-title style="color: white">
            {{ $t(title) }}
          </v-toolbar-title>

          <v-spacer />

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="append"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click="setDefault"
              >
                <v-icon color="white">
                  mdi-account-check-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('set-to-default') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="$store.state.permissions && $store.state.permissions.includes('customer') && newBtn && type === 'person'"
                color="white"
                v-bind="attrs"
                icon
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="accountDialog = true"
              >
                <v-icon
                  style="font-size: 26px"
                  color="white"
                >
                  mdi-account-plus-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-account') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$store.state.permissions && $store.state.permissions.includes('Product') && (newBtn && type === 'product'|| newBtn && type === 'productService')"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="productDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'product' || newBtn && type === 'productService'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="barcodeDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-barcode-scan
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'given'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                tabindex="-1"
                v-on="on"
                @click.stop.prevent="givenDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('given') }}</span>
          </v-tooltip>
          <template v-slot:extension>
            <div
              style="width: 100%;padding-top: 10px"
            >
              <v-text-field
                v-model="mobileSearch"
                :label="$t('search')"
                solo
                flat
                :loading="isLoading"
                height="45"
                clearable
              >
                <template v-slot:append>
                  <v-fade-transition leave-absolute>
                    <v-progress-circular
                      v-if="isLoading"
                      size="24"
                      color="green"
                      indeterminate
                    />
                  </v-fade-transition>
                </template>
              </v-text-field>
            </div>
          </template>
        </v-app-bar>
        <v-list style="margin-top: 98px">
          <!--          <v-subheader>REPORTS</v-subheader>-->
          <v-list-item-group
            v-model="mobileModel"
            color="primary"
            :multiple="(multiple ? multiple : null)"
            style="overflow-y: scroll;overflow-x: hidden;min-height: 400px;"
          >
            <v-list-item
              v-for="(item, index) in mobileItems"
              :key="index"
              :value="item"
              class="data-table-list-items px-0"
              :class="{
                'mobile-td-list-border-primary': (!item.remain || item.remain && item.remain.remain == 0 ? true : false ),
                'mobile-td-list-border-red': (item.remain && item.remain.remain > 0 ? true : false ),
                'mobile-td-list-border-green': (item.remain && item.remain.remain < 0 ? true : false ),
              }"
              elevation="4"
            >
              <v-list-item-icon class="ps-2 me-1">
                <p class="mt-1">
                  {{ +index + +1 }}
                </p>
              </v-list-item-icon>
              <v-list-item-content class="ms-3">
                <v-list-item-title class="text-wrap">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="type === 'person'"
                  class="text-wrap mt-1"
                >
                  <a
                    v-if="item.phone"
                    :href="'tel:' + item.phone"
                    style="font-size: 14px"
                  >
                    {{$t('phone')}} : {{ item.phone }}
                  </a>
                  <a
                    v-if="item.mobile && type === 'person'"
                    :href="'tel:' + item.mobile"
                    style="font-size: 14px"
                    class="mt-1"
                  >
                    {{$t('mobile')}} : {{ item.mobile }}
                  </a>
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.email && type === 'person'"
                  class="text-wrap"
                  style="font-size: 14px !important;"
                >
                  {{ $t('email') }} : {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action
                class="d-inline"
                @click.stop
              >
                <v-btn
                  v-if="newBtn && $store.state.permissions.includes('removeCategoryItem')"
                  icon
                  small
                  @click.stop.prevent="edit(item)"
                >
                  <v-icon color="grey">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="newBtn && $store.state.permissions.includes('removeCategoryItem')"
                  small
                  icon
                  @click.stop.prevent="removeItem(item)"
                >
                  <v-icon color="pink">
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item class="justify-center">
              <div
                v-if="mobileItems && mobileItems.length !== 0 && last_page > 1 && last_page > page"
                v-observe-visibility="{
                  callback: visibilityChanged
                }"
                width="100%"
                height="40px"
                class="d-flex my-0 pa-2"
              >
                <v-progress-circular
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </div>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="accountDialog"
      width="80%"
    >
      <v-card>
        <v-form
          ref="form"
          lazy-validation
        >
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t(title) }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style="height: 100px"
          >
            <v-row class="pa-0 ma-0">
              <v-col cols="6">
                <v-text-field
                  v-model="newItem"
                  :label="$t('name') + ' ' + $t(title)"
                  height="20"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
              v-shortkey="['enter']"
              @shortkey="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="accountDialog = false"
              v-shortkey="['esc']"
              @shortkey="accountDialog = false"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import General from '../../../../../Mixins/general'
  export default {
    name: 'aicomplete',
    components: {
    },
    props: ['type', 'append', 'newBtn', 'title', 'currencyProp', 'data', 'multiple', 'rules', 'init', 'setInit', 'parent', 'val', 'flat', 'backroundColor', 'outlined', 'solo', 'height', 'offDens', 'cacheItems'],
    data: () => ({
      mobileDialog: false,
      accountDialog: false,
      isLastPage: false,
      isLoading: false,
      appendIcon: 'chevron-down',
      snakbar: false,
      select: null,
      newAccount: null,
      last_page: 1,
      searchKey: true,
      newItemId: null,
      currency: null,
      businessId: null,
      snakbarText: null,
      snakbarColor: null,
      text: null,
      items: [],
      id: null,
      // items: Array.from(Array(10).keys()),
      model: null,
      parentId: null,
      search: null,
      page: 1,
      timer: null,
      notFind: null,
      newItem: null,
      deleteItemId: null,
      additionalData: null,
      configData: null,
      tab: null,
      initList: null,
      setInitial: false,
      mobileModel: null,
      mobileSearch: null,
      mobileItems: [],
    }),
    mixins: [General],
    watch: {
      page () {
      },
      val () {
        if (this.val) {
          this.setModel(this.val)
        } else {
          this.model = null
        }
      },
      parent (val, old) {
        if (this.parent) {
          this.parentId = this.parent
        } else {
          this.parentId = null
        }
        if (val !== old) {
          this.clear()
          this.initList = false
          this.getItems({ query: null, page: 1 })
        }
      },
      newAccount () {
        if (this.newAccount) {
          this.accountDialog = false
          this.setModel(this.newAccount)
        }
      },
      model (val) {
        if (val != null) {
          this.tab = 0
          if (this.notFind) {
            this.text = this.$t('alert-register-success')
            this.snakbar = true
          }
          this.$emit('input', this.model)
        } else {
          this.tab = null
          this.$emit('input', null)
        }
      },
      search (val) {
        if (this.model && this.model.name === val) {
          return false
        }
        if (!this.isMobile && this.searchKey) {
          this.page = 1
          if (!this.setInitial) {
            this.items = []
          }
          this.setInitial = false
          this.getItems()
        }
      },
      currencyProp () {
        this.currency = this.currencyProp
        this.items = []
        this.page = 1
        this.initList = false
        this.getItems()
      },
      mobileSearch () {
        this.page = 1
        this.setInitial = false
        this.items = []
        this.mobileItems = []
        this.getItems()
      },
      mobileModel (val) {
        this.$emit('input', val)
        if (!this.multiple) {
          this.mobileDialog = false
        }
      },
    },
    mounted  () {
      this.setInitial = this.setInit
      this.currency = JSON.parse(localStorage.getItem('token')).init.currency
      if (this.currencyProp) {
        this.currency = this.currencyProp
      }
      if (this.val) {
        this.setModel(this.val)
      } else {
        this.getItems({ query: null, page: 1 })
      }
    },
    methods: {
      openMobileDialog () {
        if (this.isMobile) {
          this.mobileDialog = true
          if (this.page === 1 && this.mobileItems.length === 0) {
            this.getItems()
          }
        }
      },
      onclear () {
        // this.$emit('clear')
        this.getItems()
      },
      openNew () {
        this.model = null
        this.accountDialog = true
      },
      edit (item) {
        this.newItem = item.name
        this.newItemId = item.id
        // this.model = null
        this.accountDialog = true
      },
      removeItem (item) {
        this.newItem = item.name
        this.deleteItemId = item.id
        this.create()
      },
      remove (item) {
        var index = this.model.findIndex(x => x.id === item.id && x.type === item.type)
        if (index >= 0) this.model.splice(index, 1)
      },
      create () {
        if (!this.deleteItemId && !this.$refs.form.validate()) return false
        var app = this
        app.additionalData = app.data
        if (app.data !== undefined) {
          app.configData = JSON.parse(app.data)
        }
        app.select = app.type
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'createdetail', this.$data)
          .then(res => {
            var index = null
            var i
            if (!app.isMobile) {
              if (this.deleteItemId) {
                index = app.items.findIndex(x => x.id === app.deleteItemId)
                app.items.splice(index, 1)
                if (app.model && app.deleteItemId === app.model.id) {
                  app.model = null
                }
              } else {
                if (this.newItemId) {
                  i = this.items.findIndex(x => x.id === app.newItemId)
                  if (i >= 0) {
                    this.items[i].name = res.data.data.name
                  }
                }
                app.items.push(res.data.data)
                app.model = res.data.data
              }
            } else {
              if (this.deleteItemId) {
                index = app.mobileItems.findIndex(x => x.id === app.deleteItemId)
                app.mobileItems.splice(index, 1)
                if (app.model && app.deleteItemId === app.model.id) {
                  app.model = null
                }
              } else {
                if (this.newItemId) {
                  i = this.mobileItems.findIndex(x => x.id === app.newItemId)
                  if (i >= 0) {
                    this.mobileItems[i].name = res.data.data.name
                  }
                }
                app.items.push(res.data.data)
                // app.mobileItems.push(res.data.data)
                app.model = res.data.data
              }
            }
            app.newItem = null
            app.newItemId = null
            app.deleteItemId = null
            app.accountDialog = false
            app.snakbar = false
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => {
            app.isLoading = false
            app.snakbar = false
          })
      },
      setDefault () {
        var app = this
        if (app.model) {
          app.isLoading = true
          app.$axios.get(this.$endpoint + 'getdetail', {
            params: {
              select: 'setDefaultAccount',
              id: app.model,
            },
          })
            .then(res => {
              app.$emit('snackbarShow', { text: res.data.message, color: 'green' })
            })
            .catch(err => {
              var error = err.response
              if (error.status === 500) {
                app.$emit('snackbarShow', { text: error.data.message, color: 'red' })
              }
              if (error.status === 401) {
                app.$router.push({ name: 'logout' })
              }
            })
            .finally(() => (app.isLoading = false))
        }
      },
      setModel (item) {
        // this.items = [item]
        var app = this
        if (this.multiple) {
          app.items = [
            ...app.items,
            ...Array.from(item),
          ]
        } else {
          this.items.push(item)
        }
        this.model = item
        this.id = item
      },
      clear () {
        this.items = []
        this.model = null
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems () {
        this.loading = true
        // simulates ajax request
        if (this.page === 1 && this.search == null && this.initList && !this.isMobile) {
          return false
        }
        this.initList = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail?select=' + app.type + '&search=' + (app.isMobile ? app.mobileSearch : app.search) + '&page=' + app.page + '&currency=' + app.currency + '&data=' + app.data + '&parent_id=' + app.parentId)
            .then(res => {
              res = res.data
              app.last_page = res.last_page
              var setDef = false
              if (app.setInitial && app.page === 1) {
                setDef = true
              }
              if (res.last_page > app.page) {
                app.page++
              }
              if (res.last_page === res.current_page) {
                app.last_page = 1
              }
              if (!app.isMobile) {
                app.items = [
                  ...app.items,
                  ...Array.from(res.data),
                ]
              } else {
                app.mobileItems = [
                  ...app.mobileItems,
                  ...Array.from(res.data),
                ]
              }
              if (setDef) {
                app.searchKey = false
                if (!app.isMobile) {
                  app.model = app.items[0]
                } else {
                  app.mobileModel = app.mobileItems[0]
                }
                setTimeout(function () {
                  app.searchKey = true
                }, 1000)
              }
              if (res.data.length > 0) {
                app.notFind = null
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 500)
        // setTimeout(() => {
        //   app.$refs.autocomplete.onScroll()
        // }, 1500)
        this.loading = false
      },
    },
  }
</script>

<style scoped>
  .v-progress-circular {
    margin: 4px;
  }
</style>
